import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a vehicle camera overview icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <VehicleCameraIcon width={12} />
 */
const VehicleCameraOverviewIcon = props => (
    <SvgIcon {...props}>
        <path d="m23.54,23.98h10.46v-4.98c0-1.66-.67-3.67-1.5-4.5l-.97-.97c-.29-.29-.64-.85-.77-1.24l-1.81-5.44c-.52-1.57-2.29-2.85-3.95-2.85h-12c-1.66,0-3.42,1.27-3.95,2.85l-1.81,5.44c-.13.39-.47.95-.77,1.24-.26.26-.6.6-.97.97-.83.83-1.5,2.84-1.5,4.5v9c0,.83.67,1.5,1.5,1.5h3c.83,0,1.5-.67,1.5-1.5v-1.5h10.17c.44-1.45,1.78-2.52,3.37-2.52Zm8.96-4.23c0,1.24-1.01,2.25-2.25,2.25s-2.25-1.01-2.25-2.25,1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25Zm-23.68-7.46l1.66-4.97c.32-.95,1.52-1.82,2.53-1.82h12c1,0,2.21.87,2.53,1.82l1.66,4.97c.13.39-.1.71-.51.71H9.33c-.41,0-.64-.32-.51-.71Zm-1.07,9.71c-1.24,0-2.25-1.01-2.25-2.25s1.01-2.25,2.25-2.25,2.25,1.01,2.25,2.25-1.01,2.25-2.25,2.25Zm5.25.75c0-.41.34-.75.75-.75h10.5c.41,0,.75.34.75.75s-.34.75-.75.75h-10.5c-.41,0-.75-.34-.75-.75Zm25.03,6.65v9.2c0,.77-.61,1.4-1.36,1.4h-11.31c-.75,0-1.36-.63-1.36-1.4v-9.2c0-.77.61-1.4,1.36-1.4h11.31c.75,0,1.36.63,1.36,1.4Zm.97,2.73v3.77l5,2.61v-8.99l-5,2.61Z" />
    </SvgIcon>
)

VehicleCameraOverviewIcon.defaultProps = defaultProps

export { VehicleCameraOverviewIcon }
